// reducer.js
/*eslint-disable*/
import {
  FETCH_CHANNEL_CREDENTIALS_DATA_FAILURE,
  FETCH_CHANNEL_CREDENTIALS_DATA_REQUEST,
  FETCH_CHANNEL_CREDENTIALS_DATA_SUCCESS,
  FETCH_CREDENTIALS_DATA_FAILURE,
  FETCH_CREDENTIALS_DATA_REQUEST,
  FETCH_CREDENTIALS_DATA_SUCCESS,
} from './actionCreator';

const initialState = {
  credential: {},
  data: {},
  loading: false,
  error: null,
};

const credentialsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREDENTIALS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CREDENTIALS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        credential: action.payload,
        error: null,
      };
    case FETCH_CREDENTIALS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_CHANNEL_CREDENTIALS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CHANNEL_CREDENTIALS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_CHANNEL_CREDENTIALS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default credentialsReducer;
